var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[(!_vm.filterText)?_c('span',[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._v(" "),(_vm.filterText)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.label.replace(
        new RegExp(_vm.filterText, 'g'),
        `<font style='color:#000; opacity: 0.6; background:#FFE58F;'>${_vm.filterText}</font>`
      )
    )}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }